require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./project-what-mies-told-me-3.json") })
        }
      }, "path---project-what-mies-told-me-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---project-what-mies-told-me-3!./.cache/json/project-what-mies-told-me-3.json
// module id = 360
// module chunks = 231608221292675